// extracted by mini-css-extract-plugin
export default {"box":"styles_box__bTPq3","title":"styles_title__9EoEd","buttons":"styles_buttons__61RoQ","yesButton":"styles_yesButton__rYNuB","noButton":"styles_noButton__iAygg"};